import * as actionTypes from "../actions/actionTypes";

const initState = {
    whishListItems: null,
    wishListLoading: false,
    wishIdsArray: localStorage.getItem('myWish'),
    error: null,
    //adding :
    addingItem: false,
    //removing:
    removing: false
};

const initGetWishList = (state, action) => {
    return {
        ...state,
        wishListLoading: action.wishListLoading
    }
};

const successGetWishList = (state, action) => {
    return {
        ...state,
        whishListItems: action.whishListItems,
        wishListLoading: action.wishListLoading,
    }
};

const failGetWishList = (state, action) => {
    return {
        ...state,
        error: action.whishListItems,
        wishListLoading: action.wishListLoading
    }
};

const wishIdsArray = (state, action) => {
    return {
        ...state,
        wishIdsArray: action.wishIdsArray
    }
};

// ####################################### ADDING NEW ITEM TO WIHSLIST ###########################

const initAddItemToUserWishList = (state, action) => {
    return {
        ...state,
        addingItem: action.addingItem
    }
};

const successAddItemToUserWishList = (state, action) => {
    return {
        ...state,
        addingItem: action.addingItem
    }
};

const failAddItemToUserWishList = (state, action) => {
    return {
        ...state,
        addingItem: action.addingItem,
        error: action.error
    }
};

// ####################################### REMOVING  ITEM FROM WIHSLIST ###########################

const initRemoveItemFromWishList = (state, action) => {
    return {
        ...state,
        removing: action.removing
    }
};

const successRemoveItemFromWishList = (state, action) => {
    return {
        ...state,
        removing: action.removing
    }
};

const failRemoveItemFromWishList = (state, action) => {
    return {
        ...state,
        removing: action.removing,
        error: action.error
    }
};

const Reducer = (state = initState, action) => {
    switch (action.type) {
        case actionTypes.INIT_GET_WISHLIST: return initGetWishList(state, action)
        case actionTypes.SUCCESS_GET_WISHLIST: return successGetWishList(state, action)
        case actionTypes.FAIL_GET_WISHLIST: return failGetWishList(state, action)
        case actionTypes.WISH_IDS_ARRAY: return wishIdsArray(state, action)
        // Adding Item TO whishList:
        case actionTypes.INIT_ADD_ITEM_TO_USER_WISHLIST: return initAddItemToUserWishList(state, action)
        case actionTypes.SUCCESS_ADD_ITEM_TO_USER_WISHLIST: return successAddItemToUserWishList(state, action)
        case actionTypes.FAIL_ADD_ITEM_TO_USER_WISHLIST: return failAddItemToUserWishList(state, action)
        //Removeing Item from WishList :
        case actionTypes.INIT_REMOVE_ITEM_FROM_USER_WISHLIST: return initRemoveItemFromWishList(state, action)
        case actionTypes.SUCCESS_REMOVE_ITEM_FROM_USER_WISHLIST: return successRemoveItemFromWishList(state, action)
        case actionTypes.FAIL_REMOVE_ITEM_FROM_USER_WISHLIST: return failRemoveItemFromWishList(state, action)
        default: return { ...state }
    }
}

export default Reducer;